import React from 'react'
import { Trans, useTranslation } from '@mc/i18n'
import { PrivacyLink, TermsLink } from '../../links'

export const SubmitLegal = ({
  className = '',
  ctaText,
}: {
  className?: string
  ctaText?: string
}) => {
  const { t } = useTranslation('@mc/legal')

  return (
    <p className={className}>
      <Trans
        i18nKey='emailCapture.submit'
        ns='@mc/legal'
        values={{ ctaText: ctaText ?? t('emailCapture.submitLabel') }}
      >
        <TermsLink />
        <PrivacyLink />
      </Trans>
    </p>
  )
}
